import { Columns } from '@shared/interfaces/table/column-config';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';

/**
 * ValidFrom Partial Date Cell
 * One of the most commonly used date variables, shown using the DateCellRenderer
 */
export const validFromPartialTable: Columns<any> = {
  title: 'common.date.validfrom',
  key: 'validFrom',
  cellRenderer: DateCellComponent,
}
